import { usePPPLocale } from '../../usePPPLocale';
import { ALLOWED_STATUS_BY_TYPE } from '../constants';
import { isSeznamStav, isSeznamTyp } from '../typeGuards';
import {
	PPPStatusTabs,
	PPPTypeTabs,
	type PPPStatusTab,
	type PPPSeznamTabsReturnType,
} from '../types/tabs/tabs.types';
import { usePPPSeznamFilter } from './usePPPSeznamFilter';

export const usePPPSeznamTabs = (): PPPSeznamTabsReturnType => {
	const { t } = usePPPLocale();
	const { activeTypeTab, activeStatusTab, onTypeTabChange, onStatusTabChange } =
		usePPPSeznamFilter();

	const typeTabsItems: PPPSeznamTabsReturnType['pppTypeTabs']['items'] = [
		{
			label: t('seznam.sluzby.filtr.aktualni'),
			triggerIdentifier: PPPTypeTabs.AKTUALNI,
			isActive: activeTypeTab === PPPTypeTabs.AKTUALNI,
			children: null,
		},
		{
			label: t('seznam.sluzby.filtr.neplatne'),
			triggerIdentifier: PPPTypeTabs.HISTORIE,
			isActive: activeTypeTab === PPPTypeTabs.HISTORIE,
			children: null,
		},
	];

	const statusLabelByTab: Record<PPPStatusTab, string> = {
		[PPPStatusTabs.VSE]: t('seznam.sluzby.filtr.vse'),
		[PPPStatusTabs.PRIJATO]: t('seznam.sluzby.filtr.prijato'),
		[PPPStatusTabs.SCHVALENO]: t('seznam.sluzby.filtr.schvaleno'),
		[PPPStatusTabs.ODESLANO_K_DOPRACOVANI]: t(
			'seznam.sluzby.filtr.odeslano_k_dopracovani'
		),
		[PPPStatusTabs.ODESLANO_SPRAVCI]: t('seznam.sluzby.filtr.odeslano_spravci'),
		[PPPStatusTabs.ZAMITNUTO]: t('seznam.sluzby.filtr.zamitnuto'),
		[PPPStatusTabs.UKONCENO]: t('seznam.sluzby.filtr.ukonceno'),
	};

	const statusTabsItems: PPPSeznamTabsReturnType['pppStatusTabs']['items'] =
		ALLOWED_STATUS_BY_TYPE[activeTypeTab].map((statusTab) => ({
			label: statusLabelByTab[statusTab],
			triggerIdentifier: statusTab,
			isActive: activeStatusTab === statusTab,
			children: null,
		}));

	return {
		pppTypeTabs: {
			activeTab: activeTypeTab,
			items: typeTabsItems,
			onTabChange: (identifier) => {
				if (!isSeznamTyp(identifier)) return;
				onTypeTabChange(identifier);
			},
		},
		pppStatusTabs: {
			activeTab: activeStatusTab,
			items: statusTabsItems,
			onTabChange: (identifier) => {
				if (!isSeznamStav(identifier)) return;
				onStatusTabChange(identifier);
			},
		},
	};
};
